import { Link, useLocation } from 'react-router-dom';
import { Icon } from './Icon';
import { Freshness } from './Freshness';
import { ThemeToggle } from './ThemeToggle';
import { LiveActivity } from './LiveActivity';
import { useBrand } from '../lib/brand';
import { findPage, pathFor } from '../lib/nav';
import { useLastCollected } from '../lib/queries/shell';

/**
 * The 60px sticky top bar: menu button (phones), breadcrumb (brand / screen), the freshness pill
 * for the newest finished job, and the theme toggle.
 */
export function TopBar({ onMenu, menuOpen }: { onMenu: () => void; menuOpen: boolean }) {
  const { pathname } = useLocation();
  const { brand, routeBrandId } = useBrand();
  const page = findPage(pathname);
  const onBrandPage = !!page?.brand && !!routeBrandId;
  const collected = useLastCollected(onBrandPage ? (brand?.id ?? routeBrandId) : null);

  return (
    <header className="top">
      <button
        type="button"
        className="theme-btn menu-btn"
        aria-label="Open menu"
        aria-expanded={menuOpen}
        aria-controls="sidebar"
        onClick={onMenu}
      >
        <Icon name="menu" />
      </button>
      <div className="crumb">
        <Icon name={page?.icon ?? 'doc'} />
        {onBrandPage && brand ? (
          <>
            <Link className="bn" to={pathFor('dashboard', brand.id)}>
              {brand.name}
            </Link>
            <span className="sep" aria-hidden="true">
              /
            </span>
          </>
        ) : null}
        <span className="pg">{page?.title ?? 'Not found'}</span>
      </div>
      <div className="sp" />
      <LiveActivity brandId={onBrandPage ? (brand?.id ?? routeBrandId ?? null) : null} />
      <Freshness variant="pill" prefix="Updated" at={collected.data ?? null} maxAgeHours={26} />
      <ThemeToggle />
    </header>
  );
}
